module.exports = __webpack_public_path__ + "media/music_bg_1.94893912.mp3";